import moment from 'moment';

const level = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error'
};

let count = 0;

export default {
  add({state, commit, dispatch}, msg) {
    if (typeof msg === 'string') {
      msg = {content: msg};
    }

    // msg: {level, title, content, stick};
    let message = {
      id: ++count,
      time: moment(),
      level: msg.level || level.info,
      title: msg.title,
      content: msg.content
    };

    commit('add', message);

    if (!msg.stick) {
      setTimeout(() => {
        dispatch('remove', message);
      }, state.timeout);
    }
  },

  addInfo({state, commit, dispatch}, msg) {
    let message = {
      level: level.info,
      content: msg
    };
    dispatch('add', message);
  },

  addWarn({state, commit, dispatch}, msg) {
    let message = {
      level: level.warning,
      content: msg
    };
    dispatch('add', message);
  },

  addError({state, commit, dispatch}, msg) {
    let message = {
      level: level.error,
      title: 'Error',
      stick: true,
      content: msg
    };
    dispatch('add', message);
  },

  addSuccess({state, commit, dispatch}, msg) {
    let message = {
      level: level.success,
      title: 'Success',
      content: msg
    };
    dispatch('add', message);
  },

  remove({state, commit}, msg) {
    if (!msg) {
      return;
    }

    for (let i = 0; i < state.messages.length; i++) {
      if (msg === state.messages[i]) {
        commit('remove', i);
        break;
      }
    }
  }
};
